import { Canton } from '@/schemas/ch/enums'

export enum Region {
  NORTHWESTERN = 'NORTHWESTERN',
  EASTERN = 'EASTERN',
  ESPACE_MIDLAND = 'ESPACE_MIDLAND',
  LAKE_GENEVA = 'LAKE_GENEVA',
  CENTRAL = 'CENTRAL',
  TICINO = 'TICINO',
  ZURICH = 'ZURICH',
}

const CANTON_TO_REGION: Record<Canton, Region> = {
  [Canton.CH_AG]: Region.NORTHWESTERN,
  [Canton.CH_BL]: Region.NORTHWESTERN,
  [Canton.CH_BS]: Region.NORTHWESTERN,

  [Canton.CH_AI]: Region.EASTERN,
  [Canton.CH_AR]: Region.EASTERN,
  [Canton.CH_GL]: Region.EASTERN,
  [Canton.CH_GR]: Region.EASTERN,
  [Canton.CH_SG]: Region.EASTERN,
  [Canton.CH_SH]: Region.EASTERN,
  [Canton.CH_TG]: Region.EASTERN,

  [Canton.CH_BE]: Region.ESPACE_MIDLAND,
  [Canton.CH_FR]: Region.ESPACE_MIDLAND,
  [Canton.CH_JU]: Region.ESPACE_MIDLAND,
  [Canton.CH_NE]: Region.ESPACE_MIDLAND,
  [Canton.CH_SO]: Region.ESPACE_MIDLAND,

  [Canton.CH_GE]: Region.LAKE_GENEVA,
  [Canton.CH_VD]: Region.LAKE_GENEVA,
  [Canton.CH_VS]: Region.LAKE_GENEVA,

  [Canton.CH_LU]: Region.CENTRAL,
  [Canton.CH_NW]: Region.CENTRAL,
  [Canton.CH_OW]: Region.CENTRAL,
  [Canton.CH_SZ]: Region.CENTRAL,
  [Canton.CH_UR]: Region.CENTRAL,
  [Canton.CH_ZG]: Region.CENTRAL,

  [Canton.CH_TI]: Region.TICINO,

  [Canton.CH_ZH]: Region.ZURICH,
}

export function getRegionForCanton(canton: Canton): Region {
  return CANTON_TO_REGION[canton]
}
